import { getStatusNameById } from 'enumHelpers';

export default function useGroupByStatus(field = 'status_id') {
    return (option) => {
        return getStatusNameById(option[field]);
    };
}
